export const SCREEN_NAME = {
    CHECKOUT: "checkout",
    CUSTOMIZATION: "customization",
    COUPON_LISTING: "coupon-screen",
    GROUP_CART: "group-cart",
};
